import { Reveal, Chapter } from "@/components/Reveal";
import { IMG, PHOTO } from "@/lib/assets";

export default function Mission() {
  return (
    <section id="mission" data-testid="mission-section" className="py-24 md:py-32 lg:py-40">
      <div className="container-x grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center">
        <div className="lg:col-span-6">
          <Reveal>
            <Chapter number="09" label="Notre mission" />
            <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl text-white leading-[1.1] tracking-tight">
              L'AUTOMOBILE,
              <br />
              <span className="gold-text">SIMPLIFIÉE.</span>
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="mt-8 text-base sm:text-lg text-slate-300 font-light leading-relaxed">
              Chez Gestion Automobile Exécutive, nous croyons que l'achat, la vente et la gestion d'un
              véhicule devraient être simples, efficaces et transparents.
            </p>
            <p className="mt-5 text-base sm:text-lg text-slate-300 font-light leading-relaxed">
              Notre rôle est de devenir votre partenaire automobile de confiance. Nous pouvons vous
              accompagner dans la recherche du véhicule idéal, la négociation, l'inspection, le
              financement, la livraison, l'entretien, le remplacement et la revente.
            </p>
          </Reveal>
          <Reveal delay={0.2}>
            <div className="mt-10 border-l-2 border-gold/60 pl-6">
              <p className="font-display text-xl sm:text-2xl text-white leading-snug">
                Un seul interlocuteur.
              </p>
              <p className="mt-2 text-sm text-slate-400 font-light">
                Une seule mission : vous faire gagner du temps et de l'argent.
              </p>
            </div>
          </Reveal>
        </div>
        <div className="lg:col-span-6">
          <Reveal delay={0.15}>
            <div className="relative mb-10">
              <div className="absolute -inset-4 border border-gold/20 rounded-2xl translate-x-4 translate-y-4" />
              <div className="relative rounded-2xl overflow-hidden border border-white/10">
                <img
                  src={PHOTO.advisor}
                  alt="Conseiller automobile en discussion naturelle avec un client dans un environnement haut de gamme"
                  className="w-full h-[380px] sm:h-[460px] object-cover"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-ink/60 to-transparent" />
              </div>
              <div className="absolute -bottom-8 -left-3 sm:-left-8 w-36 sm:w-48 rounded-xl overflow-hidden border border-white/15 shadow-2xl">
                <img
                  src={IMG.interior}
                  alt="Détail d'un habitacle haut de gamme, volant en cuir"
                  className="w-full h-24 sm:h-32 object-cover"
                  loading="lazy"
                />
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
